/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../../_chunks/dep-0b4c3c44.mjs';
import { p as pick_1 } from '../../../_chunks/dep-32e8a48d.mjs';
import { o as omit_1 } from '../../../_chunks/dep-f1423dd2.mjs';
import log from '../log/log.mjs';
import '../../../_chunks/dep-a48de419.mjs';
import '../../../_chunks/dep-0c515b62.mjs';
import '../../../_chunks/dep-3d4aad09.mjs';
import '../../../_chunks/dep-7071345f.mjs';
import '../../../_chunks/dep-977c5cdd.mjs';
import '../../../_chunks/dep-3ca5fb38.mjs';
import '../../../_chunks/dep-c27b1c14.mjs';
import '../../../_chunks/dep-9311bf66.mjs';
import '../../../_chunks/dep-4889eb51.mjs';
import '../../../_chunks/dep-0b4185fe.mjs';
import '../../../_chunks/dep-d2403b2f.mjs';
import '../../../_chunks/dep-7922050a.mjs';
import '../../../_chunks/dep-169ea640.mjs';
import '../../../_chunks/dep-a82b01df.mjs';
import '../../../_chunks/dep-192e10f1.mjs';
import '../../../_chunks/dep-759eacca.mjs';
import '../../../_chunks/dep-827c4600.mjs';
import '../../../_chunks/dep-0820e0e2.mjs';
import '../../../_chunks/dep-8e38f523.mjs';
import '../../../_chunks/dep-544fb8fd.mjs';
import '../../../_chunks/dep-caad2e91.mjs';
import '../../../_chunks/dep-59545a4d.mjs';
import '../../../_chunks/dep-72359af2.mjs';
import '../../../_chunks/dep-ad0cc3b4.mjs';
import '../../../_chunks/dep-e769aafd.mjs';
import '../../../_chunks/dep-efb50e88.mjs';
import '../../../_chunks/dep-2a7dc5c7.mjs';
import '../../../_chunks/dep-f6b25712.mjs';
import '../../../_chunks/dep-7d96367f.mjs';
import '../../../_chunks/dep-469bf54b.mjs';
import '../../../_chunks/dep-10db0930.mjs';
import '../../../_chunks/dep-83862ee1.mjs';
import '../../../_chunks/dep-52cbb58a.mjs';
import '../../../_chunks/dep-400798c5.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getExposedProps(node) {
  var props = pick_1(node, ["value", "label", "data", "actived", "expanded", "checked", "indeterminate", "loading"]);
  return props;
}

function createNodeModel(node) {
  var props = getExposedProps(node);

  var model = _objectSpread(_objectSpread({}, props), {}, {
    getLevel: function getLevel() {
      return node.getLevel();
    },
    getIndex: function getIndex() {
      return node.getIndex();
    },
    isFirst: function isFirst() {
      return node.isFirst();
    },
    isLast: function isLast() {
      return node.isLast();
    },
    isLeaf: function isLeaf() {
      return node.isLeaf();
    },
    insertBefore: function insertBefore(newData) {
      return node.insertBefore(newData);
    },
    insertAfter: function insertAfter(newData) {
      return node.insertAfter(newData);
    },
    appendData: function appendData(data) {
      return node.append(data);
    },
    getPath: function getPath() {
      var nodes = node.getPath();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getParent: function getParent() {
      var _node$parent;

      return (_node$parent = node.parent) === null || _node$parent === void 0 ? void 0 : _node$parent.getModel();
    },
    getParents: function getParents() {
      var nodes = node.getParents();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getRoot: function getRoot() {
      var root = node.getRoot();
      return root === null || root === void 0 ? void 0 : root.getModel();
    },
    getSiblings: function getSiblings() {
      var nodes = node.getSiblings();
      return nodes.map(function (item) {
        return item.getModel();
      });
    },
    getChildren: function getChildren(deep) {
      var childrenModel = false;
      var children = node.children;

      if (Array.isArray(children)) {
        if (children.length > 0) {
          if (deep) {
            var nodes = node.walk();
            nodes.shift();
            childrenModel = nodes.map(function (item) {
              return item.getModel();
            });
          } else {
            childrenModel = children.map(function (item) {
              return item.getModel();
            });
          }
        } else {
          childrenModel = false;
        }
      } else if (typeof children === "boolean") {
        childrenModel = children;
      }

      return childrenModel;
    },
    remove: function remove(value) {
      if (!value) {
        node.remove();
        return;
      }

      var tree = node.tree;
      var targetNode = tree.getNode(value);

      if (!targetNode) {
        log.warnOnce("Tree", "`".concat(value, "` is not exist"));
        return;
      }

      var parents = targetNode.getParents();
      var parentValues = parents.map(function (pnode) {
        return pnode.value;
      });

      if (parentValues.indexOf(node.value) < 0) {
        log.warnOnce("Tree", "`".concat(value, "` is not a childNode of current node"));
        return;
      }

      targetNode.remove();
    },
    setData: function setData(data) {
      var _data = omit_1(data, ["children", "value", "label"]);

      var keys = node.tree.config.keys;
      var dataValue = data[(keys === null || keys === void 0 ? void 0 : keys.value) || "value"];
      var dataLabel = data[(keys === null || keys === void 0 ? void 0 : keys.label) || "label"];
      if (dataValue !== void 0) _data.value = dataValue;
      if (dataLabel !== void 0) _data.label = dataLabel;
      Object.assign(node.data, _data);
      Object.assign(node, _data);
    }
  });

  return model;
}
function updateNodeModel(model, node) {
  var props = getExposedProps(node);
  Object.assign(model, props);
}

export { createNodeModel, updateNodeModel };
//# sourceMappingURL=tree-node-model.mjs.map
